import { uiKz } from './uiKz';

const NAV_LABELS = {
  'О нас': 'Біз туралы',
  'История и функционал': 'Тарихы мен функциясы',
  'Совет директоров': 'Директорлар кеңесі',
  'Правление': 'Басқарма',
  'Руководство': 'Басшылық',
  'Организационная структура': 'Ұйымдық құрылым',
  'ГОНС и Келешек': 'МББЖ және Келешек',
  'Подушевое нормативное финансирование': 'Жан басына шаққандағы нормативтік қаржыландыру',
  'Дошкольное образование': 'Мектепке дейінгі білім',
  'Среднее образование': 'Орта білім',
  'ТиППО': 'ТЖКБ',
  'ОВПО': 'ЖОКББ',
  'Дополнительное образование': 'Қосымша білім',
  'Отработка грантов': 'Гранттарды өтеу',
  'Бакалавриат': 'Бакалавриат',
  'Магистратура': 'Магистратура',
  'Докторантура': 'Докторантура',
  'Оплата задолженности': 'Берешекті өтеу',
  'Инвесторам': 'Инвесторларға',
  'Новости': 'Жаңалықтар',
  'Контакты': 'Байланыс',
};

const PORTAL_LABELS = {
  'По школам': 'Мектептер бойынша',
  'По бюджету': 'Бюджет бойынша',
  'Аналитика': 'Аналитика',
};

const PNF_KZ = {
  gons: {
    tag: 'МББЖ және Келешек',
    title: 'Мемлекеттік білім беру жинақтау жүйесі',
    subtitle: '«Балаларға ұлттық қор», Келешек, «Ақыл» депозиттері',
    stats: ['БСК/СКЖ салымдары', 'жинақтар', 'мемлекеттік сыйақылар', 'мониторингтегі түлектер'],
    desc: '«Балаларға ұлттық қор»: 1-18 жас, 2025 жылы 232,94 $. «Ақыл» депозиті - жастық шектеусіз. Мемлекеттік сыйақы: 7% (АӘКТ), 5% (барлығы). БКК: 5 жаста барлық балаларға 60 АЕК.',
  },
  preschool: {
    tag: 'Мектепке дейінгі білім',
    title: 'Мектепке дейінгі тәрбие және оқыту',
    subtitle: 'Жеке және мемлекеттік балабақшаларды ваучерлік қаржыландыру',
    stats: ['балабақша', 'тәрбиеленуші', 'орташа норматив', '2026 ж. МТ көлемі'],
    desc: 'Пилоттық жобаның 2 механизмі. 2026 жылдың наурызынан бастап e-Qazyna-ға ауқымды көшу. Нормативке ЕҚЖ, оқу шығындары, ғимарат ұстау кіреді.',
  },
  school: {
    tag: 'Орта білім',
    title: 'Орта білім',
    subtitle: 'Мектептерді жан басына шаққан нормативтік қаржыландыру',
    stats: ['мектеп', 'оқушы', 'норматив (мем.)', '2026 ж. МТ көлемі'],
    desc: 'Мемлекеттік мектептерді e-Qazyna-да цифрландыру - 2026 жылғы 12 ақпандан. Жеке мектептерге А2/А3 компоненттері. 416 мың педагог.',
  },
  tippo: {
    tag: 'ТЖКБ',
    title: 'Техникалық және кәсіптік білім',
    subtitle: 'Колледждерді лига және шығын топтары бойынша ранжирлеу',
    stats: ['колледж', 'студент', 'орташа норматив', '2026 ж. МТ көлемі'],
    desc: '4 шығын тобы (А, Б, В, Г) және 3 сапа лигасы. 2026 жылдың мамырынан e-Qazyna-ға көшу. 2026 жылы ранжирлеуге 60,8 млрд теңге.',
  },
  ovpo: {
    tag: 'ЖОКББ',
    title: 'Жоғары және жоғары оқу орнынан кейінгі білім',
    subtitle: 'ҚР және шетелдік ЖОО-ға мемлекеттік тапсырыс',
    stats: ['ЖОО', 'студент', 'норматив (ерекше ст. жоқ)', '2026 ж. МТ көлемі'],
    desc: '2026 жылдың желтоқсанына дейін e-Qazyna-ға көшу. Бірыңғай есептеу үшін Z1+Z2+Z3 жаңа формуласы. 15 шетелдік қатысуы бар ЖОО.',
  },
  extra: {
    tag: 'Қосымша білім',
    title: 'Қосымша білім',
    subtitle: 'Үйірмелер мен секцияларды ваучерлік қаржыландыру',
    stats: ['ұйым', 'оқушы', 'үйірме мен секция', '2026 ж. МТ көлемі'],
    desc: '2025 жылғы 1 маусымнан пилот (1728 жеке ҚБО). Пилот аяқталуы - 2026 жылғы 1 қыркүйек. Қалалар: Астана (qosymsha.kz), Шымкент (Миндаль).',
  },
  dorms: {
    tag: 'Жатақхана',
    title: 'Студенттерді жатақхана орындарымен қамтамасыз ету',
    subtitle: 'Төсек-орындарды қамтамасыз ету бойынша мемлекеттік тапсырыс',
    stats: ['жатақхана', 'төсек-орын', '2026 жоспарланған', 'қос. қаржы қажеттілігі'],
    desc: '72 жатақхана бойынша: ЖОББМ - 7,6 млрд тг, БМ - 3,9 млрд тг. Алдын ала шарттар мен мақсатты бағыттың өзгермейтіндігі туралы келісімдер механизмі.',
  },
};

const HERO_KZ = [
  {
    badge: '«Қаржы орталығы» АҚ - Қазақстан',
    title: ['Мемлекеттік', 'бағдарламаларды', 'қаржыландыру интеграторы'],
    titleLines: ['Мемлекеттік', 'бағдарламаларды', 'қаржыландыру интеграторы'],
    subtitle:
      'Қаражатты бөлудің цифрлық, нормативтік және аналитикалық механизмдерін әзірлеу және сүйемелдеу. Ашық ережелер. Салыстырмалы параметрлер. Шешімдер негізінде - деректер.',
    cta1: { label: 'Бағдарламалар туралы', href: '#pnf' },
    cta2: { label: 'Тарих', href: '#story' },
  },
  {
    badge: 'Білім беру жинақтау жүйесі',
    title: ['МББЖ және', '«Келешек»', 'бағдарламасы'],
    subtitle:
      'Мемлекеттік білім беру жинақтау жүйесі - әр баланың болашағына инвестиция. Жинақтау, гранттар және кредиттер бірыңғай цифрлық экожүйеде.',
    cta1: { label: 'Толығырақ', href: '#pnf-gons' },
    cta2: { label: 'FAQ', href: '#faq' },
  },
  {
    badge: 'Цифрлық трансформация',
    title: ['Бірыңғай', 'e-Qazyna', 'платформасы'],
    subtitle:
      '8 бөлінген жүйеден бірыңғай e-Qazyna порталына көшу. Барлық білім беру деңгейлерінде ашықтық, автоматтандыру және мақсатсыз шығындарды болдырмау.',
    cta1: { label: '2028 стратегиясы', href: '#strategy' },
    cta2: { label: 'Презентация', href: '#faq' },
  },
];

const TICKER_KZ = [
  'Мектепке дейінгі білімді ваучерлік қаржыландыру: 11 909 балабақша, 988 мың тәрбиеленуші',
  'Орта білім: 9 193 мектеп, 3 964 мың оқушы - e-Qazyna-ға көшу',
  'ТЖКБ: 763 колледж, 556 мың студент, норматив 528 177 теңге',
  'ЖОКББ: 123 ЖОО, 752 мың студент, МТ көлемі ~504 млрд теңге',
  'ЖОКББ стипендиялары: 240 мың студент, 2026 жылы ~174 млрд теңге',
  '«Келешек» МББЖ: БСК және СКЖ-да 190 522 салым, 35,9 млрд теңге жинақ',
  'Цифрлық трансформация: барлық білім деңгейлерін цифрландыру мерзімі - 2026 жыл',
];

const STATS_KZ = [
  { label: '2026 ж. МТ көлемі', sub: 'барлық білім беру деңгейлері бойынша' },
  { label: 'Білім беру ұйымдары', sub: 'e-Qazyna цифрлық тізілімінде' },
  { label: 'Қаржыландыру алушылар', sub: 'студенттер, тәрбиеленушілер, оқушылар' },
  { label: 'Инвестициялық модель', sub: 'трансформацияның мақсатты жылы' },
];

const TIMELINE_KZ = [
  { tag: 'Құрылу', title: 'Қаржы операторын іске қосу', desc: 'Әлеуметтік салада қаржыландыру механизмдерін іске асыруды қамтамасыз ететін институтты қалыптастыру.' },
  { tag: 'Жүйелілік', title: 'Бірыңғай әдіснама және нормативтік модельдер', desc: 'Қаражатты бөлу нормативтік принциптерін және бағдарламалар бойынша параметрлер салыстырмалығын дамыту.' },
  { tag: 'Цифрландыру', title: 'Цифрлық тізілімдерге көшу', desc: 'Процестерді автоматтандыру, деректерді верификациялау және қаражат бөлу кезінде қолмен бақылау үлесін азайту.' },
  { tag: 'Аналитика', title: 'Мониторинг және тиімділікті бағалау', desc: 'Көрсеткіштер витриналары, деректер сапасын бақылау және МБ тиімділігі метрикалары.' },
  { tag: 'МББЖ', title: 'Мемлекеттік жинақтау жүйесі', desc: '«Келешек» - «Ақыл» депозиттерімен балаларды кең ауқымды қамту, БСК және СКЖ интеграциясы.' },
  { tag: 'Трансформация', title: 'Стратегиялық қайта бағалау', desc: '«Мемлекеттік бағдарламаларды қаржыландыру интеграторы» ребрендингі. 2028 жылға инвестициялық модель концепциясы.' },
  { tag: 'e-Qazyna', title: 'Бірыңғай цифрлық платформа', desc: 'Барлық білім деңгейлері e-Qazyna жүйесіне көшеді. 8 жүйедегі фрагментацияны жою.' },
];

const NEWS_TAG_KZ = {
  'Главное': 'Негізгі',
  'ГОНС': 'МББЖ',
  'Дошкольное': 'Мектепке дейінгі',
  'Стратегия': 'Стратегия',
  'ОВПО': 'ЖОКББ',
};

function trNav(items) {
  return items.map((item) => ({
    ...item,
    label: NAV_LABELS[item.label] || item.label,
    submenu: item.submenu?.map((sub) => ({
      ...sub,
      label: NAV_LABELS[sub.label] || sub.label,
    })),
  }));
}

function trPnf(programs) {
  return programs.map((p) => {
    const kz = PNF_KZ[p.id];
    if (!kz) return p;
    return {
      ...p,
      tag: kz.tag,
      title: kz.title,
      subtitle: kz.subtitle,
      desc: kz.desc,
      stats: p.stats.map((s, i) => ({ ...s, l: kz.stats[i] || s.l })),
      portals: p.portals.map((portal) => ({
        ...portal,
        label: PORTAL_LABELS[portal.label] || portal.label,
      })),
    };
  });
}

function trHero(slides) {
  return slides.map((slide, i) => {
    const kz = HERO_KZ[i];
    if (!kz) return slide;
    return {
      ...slide,
      badge: kz.badge,
      title: kz.title,
      subtitle: kz.subtitle,
      cta1: { ...slide.cta1, label: kz.cta1.label },
      cta2: { ...slide.cta2, label: kz.cta2.label },
    };
  });
}

function trStats(stats) {
  return stats.map((s, i) => ({
    ...s,
    label: STATS_KZ[i]?.label ?? s.label,
    sub: STATS_KZ[i]?.sub ?? s.sub,
  }));
}

function trTimeline(items) {
  return items.map((item, i) => ({
    ...item,
    tag: TIMELINE_KZ[i]?.tag ?? item.tag,
    title: TIMELINE_KZ[i]?.title ?? item.title,
    desc: TIMELINE_KZ[i]?.desc ?? item.desc,
  }));
}

function trNews(items) {
  return items.map((n) => ({
    ...n,
    tagKey: n.tag,
    tag: NEWS_TAG_KZ[n.tag] || n.tag,
    title: NEWS_TITLES_KZ[n.image] || n.title,
    excerpt: NEWS_EXCERPTS_KZ[n.image] || n.excerpt,
  }));
}

// News translations keyed by image id
const NEWS_TITLES_KZ = {
  '10-04': '«Қаржы орталығы» АҚ трансформациясы',
  '10-06': '«Келешек» МББЖ бағдарламасы бойынша жинақтау өнімдерінің қамтуы кеңейеді',
  '19-02': 'Мектепке дейінгі білімді ваучерлік қаржыландыру өңірлер бойынша масштабталады',
  '17-12': 'Білім беруді қаржыландыруды 2028 жылға дейін трансформациялау жол картасы жаңартылды',
  '26-02': 'ЖОКББ қаржыландыру моделі және мемлекеттік тапсырысты сүйемелдеу жетілдірілуде',
  '27-01': 'Білім бағдарламалары алушыларына цифрлық сервистер қолжетімдірек болды',
  '24-16': 'Білім ұйымдарын индикаторлық бағалау концепциясы ұсынылды',
  '18-02': 'Жеке мектепке дейінгі ұйымдарды қаржыландыру ережелері жаңартылды',
  '19-05': 'ЖОО-да мемлекеттік білім беру тапсырысын цифрлық сүйемелдеу пилоты іске қосылды',
  '22-05': '«Қаржы орталығы» АҚ 2026 жылғы I тоқсан қорытындысын жариялады',
};

const NEWS_EXCERPTS_KZ = {
  '10-04': 'Бүгін біз білім беру саласын қаржыландыруды трансформациялау концепциясын іске асыру бойынша «Қаржы орталығы» АҚ командасымен стратегиялық сессия өткіздік.',
  '10-06': 'Қаржы орталығы салымшыларды сүйемелдеуді және банктер мен сақтандыру ұйымдарымен цифрлық өзара әрекеттестікті күшейтуде.',
  '19-02': 'Аkimаттар мен жеткізушілердің ашық модельге қосылуы жалғасуда - қаржыландыру балаға еріп жүреді.',
  '17-12': 'Негізгі бағыттар: Data Hub, индикаторлық модель, цифрлық тізілім және инвестициялық тәсілдің жаңа механизмдері.',
  '26-02': 'Қаржы орталығы жоғары оқу орны секторы үшін есептеулерді бірыңғайландыру және процедураларды цифрландыру жұмысын жалғастыруда.',
  '27-01': 'Клиенттік жол кеңейеді: консультациядан өтінім беруге және мәртебені онлайн бақылауға дейін.',
  '24-16': 'Жаңа құрал ұйымдардың басқару сапасы, қаржылық тұрақтылығы мен білім беру нәтижелерін объективті бағалауға мүмкіндік береді.',
  '18-02': 'Түзетулер қосылу шарттарын және нақты қатысуға негізделген субсидияларды есептеуді нақтылайды.',
  '19-05': 'Пилот аясында студенттер контингентін автоматты салыстыру және ЖБШ көлемін бірыңғай платформа арқылы есептеу өңделуде.',
  '22-05': '2026 жылғы I тоқсанда білім беруді қаржыландыру өткен жылдың сәйкес кезеңімен салыстырғанда 12%-ға өсті. МТ қамтуы 7,5 млн оқушыдан асты.',
};

function trFaq(items) {
  const FAQ_KZ = [
    {
      q: 'Білім беру ұйымдары e-Qazyna-ға қалай көшеді?',
      a: 'Көшу кезең-кезеңімен: мектепке дейінгі - 2026 наурыз, мектеп асханасы - сәуір, ТЖКБ - мамыр, қосымша білім - маусым, ЖОКББ - 2026 жылдың екінші жартысы. Әр кезең БМ, ҚҚ және akimatтардың бірлескен бұйрығымен сүйемелденеді.',
    },
    {
      q: 'Мектепке дейінгі білімде ваучерлік қаржыландыру деген не?',
      a: 'Қаражат балаға еріккен механизм: ЖАО жеткізушілер тізімін қалыптастырады, ҚО мемлекеттік сатып алу порталында қосылу шарттарын орналастырады, балабақшалар қатысу кестесін толтырады, ҚО СТЖ өткізіп, қаражат аударады. INDIGO, Balabaqsha, SmartNation және басқа ЖАО АЖ арқылы жүзеге асырылады.',
    },
    {
      q: 'ТЖКБ үшін жан басына норматив қалай есептеледі?',
      a: 'Норматив ЕҚЖ (55,7%), оқу шығындары (16%), оқу әдебиеті (2,1%), амортизация (16,2%), демоэкзамен (1,2%), коммуналдық қызметтер (11,2%) және екілік оқыту (3,9%) тұрады. Колледждер 4 шығын тобы (А-Г) және 3 лигаға бөлінеді.',
    },
    {
      q: '«Келешек» МББЖ және «Ақыл» депозиті қалай жұмыс істейді?',
      a: 'МББЖ - балалар біліміне жинақтау жүйесі. «Ақыл» депозиті банк немесе сақтандыру компаниясында жас шектеусіз ашылады. Мемлекет сыйақы есептейді: АӘКТ отбасыларына 7%, барлығына 5%. «Келешек» - 5 жаста 60 АЕК БКК және жыл сайын 24 АЕК жарна.',
    },
    {
      q: 'Жеке мектептердегі А2/А3 амортизация компоненттерінің мәселелері қандай?',
      a: '101 мектеп бойынша артық төлем 65,2 млрд теңгені құрайды, себебі құрылыс нақты құны туралы растайтын құжаттарсыз шарттар жасалған. Akimatтарға шарттарды реттеу тапсырылды.',
    },
    {
      q: 'Білім ұйымдарын индикаторлық бағалау моделі деген не?',
      a: '5 домен бойынша 0-100 индекс: ашықтық және басқару, кадрлар, қаржылық тұрақтылық, инфрақұрылым және қауіпсіздік, оқушылар нәтижелері. 70 ұпай шегі: ≥70 - ынталандыру, <70 - нормаға жету жоспары. Data Hub-тан автоматты есептеледі.',
    },
  ];
  return items.map((item, i) => ({
    ...item,
    q: FAQ_KZ[i]?.q ?? item.q,
    a: FAQ_KZ[i]?.a ?? item.a,
  }));
}

function trWorkingOffItems(items) {
  const meta = {
    bachelor: {
      label: 'Бакалавриат',
      badge: 'Бакалавриат түлектері үшін',
      title: 'Гранттарды өтеу туралы ақпарат - Бакалавриат',
      description:
        'Мемлекеттік білім беру гранты бойынша оқып, бітірген жастар мамандығына сәйкес өтеуден өтуге міндетті.',
    },
    magistracy: {
      label: 'Магистратура',
      badge: 'Магистратура түлектері үшін',
      title: 'Гранттарды өтеу туралы ақпарат - Магистратура',
      description:
        'Мемлекеттік білім беру гранты бойынша магистратурада оқып бітірген жастар мамандығына сәйкес өтеуден өтуге міндетті.',
    },
    doctoral: {
      label: 'Докторантура',
      badge: 'Докторантура түлектері үшін',
      title: 'Гранттарды өтеу туралы ақпарат - Докторантура',
      description:
        'Докторантура түлектері оқу мерзімі аяқталғаннан кейін кемінде үш жыл профильдік ұйымдарда өтеуден өтуге міндетті.',
    },
    payment: {
      label: 'Берешекті өтеу',
      badge: 'Берешекті өтеу',
      title: 'Берешекті өтеу',
      description: 'Берешекті төлеу кезінде жастың тегі, аты, әкесінің аты, ЖСН дұрыс көрсетілуі тиіс.',
    },
  };
  return items.map((item) => {
    const kz = meta[item.id];
    if (!kz) return item;
    return { ...item, ...kz };
  });
}

function trDirCards(cards) {
  const DEPT_KZ = {
    'Управляющий директор': 'Басқарушы директор',
    'Руководитель аппарата': 'Аппарат басшысы',
    'Советник': 'Кеңесші',
    'Директор департамента исследований и методологии': 'Зерттеу және әдіснама департаменті директоры',
    'Директор департамента аналитики и инфраструктурного развития': 'Аналитика және инфрақұрылымдық даму департаменті директоры',
    'Директор департамента экономики и бухгалтерского учета': 'Экономика және бухгалтерлік есеп департаменті директоры',
    'Директор департамента (и.о. директора департамента расчетов)': 'Департамент директоры (есептеу деп. директорының м.а.)',
    'Директор департамента мониторинга': 'Мониторинг департаменті директоры',
    'Директор департамента Data-аналитики и сопровождения': 'Data-аналитика және сүйемелдеу департаменті директоры',
    'Директор департамента административной работы': 'Әкімшілік жұмыс департаменті директоры',
    'Директор юридического департамента': 'Заң департаменті директоры',
    'Корпоративный секретарь': 'Корпоративтік хатшы',
    'Служба внутреннего аудита': 'Ішкі аудит қызметі',
  };
  return cards.map((c) => ({
    ...c,
    dept: DEPT_KZ[c.dept] || c.dept,
  }));
}

export function applyKz(ru) {
  return {
    ...ru,
    WORKING_OFF_ITEMS: trWorkingOffItems(ru.WORKING_OFF_ITEMS || []),
    NAV_ITEMS: trNav(ru.NAV_ITEMS),
    HERO_SLIDES: trHero(ru.HERO_SLIDES),
    TICKER_ITEMS: TICKER_KZ,
    STATS: trStats(ru.STATS),
    PNF_PROGRAMS: trPnf(ru.PNF_PROGRAMS),
    TIMELINE: trTimeline(ru.TIMELINE),
    NEWS: trNews(ru.NEWS),
    FAQ: trFaq(ru.FAQ),
    DIR_CARDS: trDirCards(ru.DIR_CARDS),
    ui: uiKz,
    CONTACTS: {
      ...ru.CONTACTS,
      hours: uiKz.contacts.hours,
    },
  };
}
